import { Demo } from "../../api/api-generated";
import { stringIncludesIgnoreCase } from "../../utils/comparisons";
import { hasDatePassed, truncateISOString } from "../../utils/dateTime";
import { DemosItemFilter } from "./demosTypes";

export const filterConstraintChecker = (
  name: string,
  value: string,
  filters: DemosItemFilter
) => {
  if (name === "startDate") {
    if (filters.endDate && filters.endDate < value) return false;
  }
  if (name === "endDate") {
    if (filters.startDate && filters.startDate > value) return false;
  }
  return true;
};

export const filterDemoItem = (
  item: Demo,
  filters: DemosItemFilter
): boolean => {
  if (
    filters.company &&
    !stringIncludesIgnoreCase(
      item.company.companyName,
      filters.company.companyName
    )
  )
    return false;
  if (
    filters.serial &&
    !stringIncludesIgnoreCase(item.inventoryHardware?.serial, filters.serial)
  )
    return false;
  if (
    filters.startDate &&
    (item.startDate === null ||
      truncateISOString(item.startDate) < truncateISOString(filters.startDate))
  )
    return false;
  if (
    filters.endDate &&
    (item.endDate === null ||
      truncateISOString(item.endDate) > truncateISOString(filters.endDate))
  )
    return false;

  if (filters.demoActive) {
    switch (filters.demoActive) {
      case "None":
        if (item.endDate) return false;
        break;
      case "Active":
        if (!item.endDate || hasDatePassed(new Date(item.endDate)))
          return false;
        break;
      case "Expired":
        if (!item.endDate || !hasDatePassed(new Date(item.endDate)))
          return false;
        break;
    }
  }
  return true;
};

export const demosHandlerMiddleware = (
  name: string,
  value: string,
  state: any,
  autoboxValue?: object,
  autoboxLabel?: string
) => {
  if (name === "startDate") {
    // @ts-ignore
    if (state.endDate && state.endDate < value) {
      return { startDate: state.startDate };
    } else {
      return {};
    }
  } else if (name === "endDate") {
    // @ts-ignore
    if (state.startDate > value) {
      return { endDate: state.endDate };
    } else {
      return {};
    }
  }
  if (autoboxLabel) {
    if (autoboxLabel === "company") return { company: autoboxValue };
    if (autoboxLabel === "inventoryHardware")
      return { inventoryHardware: autoboxValue };
    if (autoboxLabel === "software") return { software: autoboxValue };
    if (autoboxLabel === "softwareVersion")
      return { softwareVersion: autoboxValue };
  }
  return {};
};

export const itemValidator = (item: any) => {
  if (!item.company) return false;
  if (!item.contactName) return false;
  return true;
};
